import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import QuickStartWizard from './components/QuickStartWizard';
import KnowledgeBase from './components/KnowledgeBase';
import CommunityForum from './components/CommunityForum';
import CertificationPrograms from './components/CertificationPrograms';
import SupportResources from './components/SupportResources';
import DownloadableResources from './components/DownloadableResources';

const ImplementationHub: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Implementation Hub - camlytix AI</title>
        <meta 
          name="description" 
          content="Comprehensive implementation resources, expert guidance, and community support for camlytix AI. Access guides, documentation, training programs, and 24/7 technical support." 
        />
        <meta 
          name="keywords" 
          content="implementation guide, technical support, training programs, API documentation, community forum, certification, analytics deployment" 
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <HeroSection />
          <QuickStartWizard />
          <KnowledgeBase />
          <CommunityForum />
          <CertificationPrograms />
          <SupportResources />
          <DownloadableResources />
        </main>

        <footer className="bg-authority-charcoal text-authority-charcoal-foreground py-12 px-4 md:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-4 gap-8 mb-8">
              <div>
                <h3 className="font-bold text-lg mb-4">Quick Links</h3>
                <ul className="space-y-2 text-sm opacity-80">
                  <li><a href="/homepage" className="hover:opacity-100 transition-opacity duration-300">Home</a></li>
                  <li><a href="/solutions-gallery" className="hover:opacity-100 transition-opacity duration-300">Solutions</a></li>
                  <li><a href="/industry-applications" className="hover:opacity-100 transition-opacity duration-300">Industries</a></li>
                  <li><a href="/technology-platform" className="hover:opacity-100 transition-opacity duration-300">Technology</a></li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-4">Support</h3>
                <ul className="space-y-2 text-sm opacity-80">
                  <li><a href="#knowledge-base" className="hover:opacity-100 transition-opacity duration-300">Knowledge Base</a></li>
                  <li><a href="#quick-start" className="hover:opacity-100 transition-opacity duration-300">Quick Start Guide</a></li>
                  <li><a href="/partner-ecosystem" className="hover:opacity-100 transition-opacity duration-300">Partner Network</a></li>
                  <li><button onClick={() => console.log('Contact support')} className="hover:opacity-100 transition-opacity duration-300">Contact Support</button></li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-4">Resources</h3>
                <ul className="space-y-2 text-sm opacity-80">
                  <li><button onClick={() => console.log('API docs')} className="hover:opacity-100 transition-opacity duration-300">API Documentation</button></li>
                  <li><button onClick={() => console.log('Downloads')} className="hover:opacity-100 transition-opacity duration-300">Downloads</button></li>
                  <li><button onClick={() => console.log('Certifications')} className="hover:opacity-100 transition-opacity duration-300">Certifications</button></li>
                  <li><button onClick={() => console.log('Community')} className="hover:opacity-100 transition-opacity duration-300">Community Forum</button></li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-4">Company</h3>
                <ul className="space-y-2 text-sm opacity-80">
                  <li><button onClick={() => console.log('About')} className="hover:opacity-100 transition-opacity duration-300">About Us</button></li>
                  <li><button onClick={() => console.log('Careers')} className="hover:opacity-100 transition-opacity duration-300">Careers</button></li>
                  <li><button onClick={() => console.log('Privacy')} className="hover:opacity-100 transition-opacity duration-300">Privacy Policy</button></li>
                  <li><button onClick={() => console.log('Terms')} className="hover:opacity-100 transition-opacity duration-300">Terms of Service</button></li>
                </ul>
              </div>
            </div>
            <div className="pt-8 border-t border-authority-charcoal-foreground/20 text-center text-sm opacity-80">
              <p>&copy; {new Date().getFullYear()} camlytix AI. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ImplementationHub;